import React from 'react'

export const WhatWeDo = () => {
  return (
    <>
      <h1 className="text-2xl font-bold mb-2">What We Do</h1>
      <p>
        Do you wish there was an easier way to type up your equations and formulas? If you answered yes, then you need MuVision, the app that can read your math homework and convert it to Latex code! 🙌 
        MuVision is a revolutionary app that uses the power of artificial intelligence to transform your handwritten math into beautiful and professional-looking latex code. 😍
        How can you try it out? It’s simple! 🤗 <br /> <br />
        First, you can draw some math equations in our demo, or take a picture and upload your math homework with your phone camera. 📸 
        Then, the app uses computer vision to read your work and generate a Latex Document. 🧠
        That’s it! You can now download the PDF docuemnt or copy and paste the latex code into your favorite editor or platform, such as Microsoft Word, Google Docs, or Overleaf. 🙌<br /> <br />
        MuVision is fast, accurate, and easy to use. It supports all types of math symbols and expressions, from basic arithmetic to advanced calculus. It can handle fractions, exponents, roots, integrals, derivatives, matrices, and more. 😎 
        MuVision is the ultimate app for students, teachers, researchers, and anyone who loves math. It saves you time and hassle, and lets you focus on the fun and creative aspects of math. 😊<br /> <br />
        Don’t wait any longer! Download MuVision today and see for yourself how amazing it is! You’ll never look at math homework the same way again! 😍<br />
      </p>
    </>
  )
}

